import { useLingui } from "@lingui/react/macro"
import { useMemo } from "react"

const SECONDS_IN_MINUTE = 60
const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE
const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR

interface Props {
  date: Date
}

export function ActivityDate({ date }: Props) {
  const label = useDateLabel(date)

  return <span suppressHydrationWarning>{label}</span>
}

const useDateLabel = (date: Date) => {
  const { t } = useLingui()

  return useMemo(() => {
    const now = new Date()
    const secondsAgo = Math.floor((now.getTime() - date.getTime()) / 1000)

    if (secondsAgo < SECONDS_IN_MINUTE) return t`just now`

    if (secondsAgo < SECONDS_IN_HOUR)
      return t`${Math.floor(secondsAgo / SECONDS_IN_MINUTE)}m ago`

    if (secondsAgo < SECONDS_IN_DAY)
      return t`${Math.floor(secondsAgo / SECONDS_IN_HOUR)}h ago`

    return t`${Math.floor(secondsAgo / SECONDS_IN_DAY)}d ago`
  }, [date, t])
}
